import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M19.4 1V19",
      stroke: "white",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("rect", {
      width: "15",
      height: "3",
      rx: "1",
      transform: "matrix(-1 0 0 1 15.4 5)",
      fill: "white"
    }, null, -1),
    _createElementVNode("rect", {
      width: "9",
      height: "3",
      rx: "1",
      transform: "matrix(-1 0 0 1 15.4 12)",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }